module.exports = __webpack_public_path__ + "static/img/header6.f612168f.jpg";